// Result outbox, partitioned by account. Persistence failure stops admission:
// an unrecorded result must never cause a second expensive execution.
export function createLocalRunJournal(storage, account) {
  const key = `apolo:local-runs:v1:${account}`;
  const read = () => {
    const raw = storage.getItem(key);
    const entries = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(entries)) throw new Error('Histórico local de tarefas inválido');
    return entries;
  };
  return {
    list: read,
    save(entry) {
      const entries = read().filter((item) => item.runId !== entry.runId);
      if (entries.length >= 50) throw new Error('Há 50 resultados pendentes; sincronize antes de executar novas tarefas');
      storage.setItem(key, JSON.stringify([...entries, entry]));
    },
    remove(runId) { storage.setItem(key, JSON.stringify(read().filter((item) => item.runId !== runId))); },
  };
}

export async function flushLocalRunJournal(journal, report, readState) {
  for (const entry of journal.list()) {
    if (!entry.result) {
      // Release journal capacity only after the server confirms termination.
      const response = await readState?.(entry.taskId, entry.runId);
      if (response?.ok && ['ok', 'failed', 'cancelled'].includes(response.data?.status)) journal.remove(entry.runId);
      continue; // Interrupted work is never replayed automatically.
    }
    const response = await report(entry.taskId, { ...entry.result, run_id: entry.runId });
    if (!response?.ok) throw new Error(response?.error || 'Resultado salvo no dispositivo; aguardando sincronização');
    journal.remove(entry.runId);
  }
}

export async function runJournaledLocalTask({ task, execute, claim, report, journal, scheduled = false }) {
  await flushLocalRunJournal(journal, report);
  const admitted = await claim(task.id, { scheduled, next_run_at: task.next_run_at });
  if (!admitted?.ok) throw new Error(admitted?.error || 'Tarefa já em execução ou agenda alterada');
  const { runId, startedAt } = admitted.data;
  const entry = { runId, taskId: task.id, startedAt };
  journal.save(entry);
  let result;
  try { result = await execute({ runId }); }
  catch (error) { result = { status: 'failed', output: '', error: error?.message || String(error) }; }
  const finishedAt = Date.now();
  entry.result = { ...result, started_at: startedAt, finished_at: finishedAt, duration_ms: finishedAt - startedAt };
  journal.save(entry);
  await flushLocalRunJournal(journal, report);
  return result;
}
